import 'css-chunksrc/client/common/resourceAllocationMenu/resourceGroups/group/styles.scss';export default {
  "group": "_group_4dfc7_1",
  "name": "_name_4dfc7_11"
};